import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from './utils/thirdParty/wrapper';

import noop from 'lodash/noop';

import { THEME_PROP_TYPE } from './constants';

export default class Captcha extends React.PureComponent {
    static propTypes = {
        /**
         * The sitekey registered withe Google recaptcha for use w/ component
         */
        sitekey: PropTypes.string.isRequired,
        /**
         * The function that should trigger when the captcha changes
         */
        onChange: PropTypes.func,
        /**
         * The function that should trigger when captcha is expired
         */
        onExpired: PropTypes.func,
        /**
         * The visual theme for the captcha
         */
        theme: THEME_PROP_TYPE,
    };

    static defaultProps = {
        onChange: noop,
        theme: 'light',
    };

    render() {
        const { sitekey, onChange, onExpired, theme } = this.props;

        return (
            <ReCAPTCHA
                className="eds-captcha"
                sitekey={sitekey}
                onChange={onChange}
                onExpired={onExpired}
                theme={theme}
            />
        );
    }
}
